import P, { P2 } from "../../../components/Paragraph";
import Widget from "../Widget";
import DonutChart from "./DonutChart";
import useStatisticsWidget from "./useStatisticsWidget";
import useIsMobile from "../../../hooks/useIsMobile";

const legend = {
  READY: "Unfinished",
  FINISHED: "Finished",
};

const colors = {
  READY: "#865c08",
  FINISHED: "#385654",
};

const StatisticsWidget = () => {
  const { chartData, isLoading } = useStatisticsWidget();
  const isMobile = useIsMobile();

  if (isMobile === true) return null;

  return (
    <Widget header={"Statistics"} isLoading={isLoading} centered lastWidget>
      <>
        <P>Problems Tackled:</P>
        <DonutChart />
        {chartData?.map((chartItem) => {
          return (
            <P2 key={chartItem?.status}>
              <b
                style={{ color: colors[chartItem?.status] }}
              >{`${chartItem?.percentage}%`}</b>
              {` ${legend[chartItem?.status]}`}
            </P2>
          );
        })}
      </>
    </Widget>
  );
};

export default StatisticsWidget;
